import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import Button from 'components/corpSite/components/shared/button'

import { spacing_1 } from 'components/corpSite/components/theme/spacing'
import { makeImageTile } from './styled'

export const RawImageTile = makeImageTile('div')
export const RawImageTileLink = makeImageTile('a')

const LinkButton = styled(Button)`
  width: 224px;
  align-self: center;
  margin-top: ${spacing_1};
  margin-bottom: ${spacing_1};

  &:hover {
    background: transparent;
  }
`

const onClick = (href) => (window.location.href = href)

function ImageTile(props) {
  return (
    <RawImageTile onClick={() => onClick(props.href)} mobileRow {...props}>
      <div className='imageText'>
        <LinkButton href={props.href} secondary emphasis disabled transparent>
          {props.header}
        </LinkButton>
        <p>{props.subheader}</p>
      </div>
    </RawImageTile>
  )
}

ImageTile.propTypes = {
  imagePath: PropTypes.string,
  header: PropTypes.string,
  subheader: PropTypes.string,
}

export default ImageTile
